<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key" :status="item.status"></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import circleMain from "@/pages/account/circle/circle-main"
export default {
  components: {
    circleMain
  },
  name: "circlePage",
  data() {
    return {
      tabData: [
        {
          name: "已生效",
          key: "circleEffect",
          comp: circleMain,
          status: "2",
        },
        {
          name: "全部",
          key: "circleAll",
          comp: circleMain,
          status: "1"
        }
      ],
      tabCur: "circleEffect"
    }
  },
  computed: {
  },
  created() {

  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
  watch: {
  }
};
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/account/circle/circle.vue